import { registerLocaleData } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import localeGB from '@angular/common/locales/en-GB';
import localeGBExtra from '@angular/common/locales/extra/en-GB';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from '@app/app.component';
import { ExportALMConfigComponent } from '@components/export-alm/export-alm-config/export-alm-config.component';
import { ExportConfigComponent } from '@components/export/export-config/export-config.component';
import { HomeComponent } from '@components/home/home.component';
import { DepositDataImportComponent } from '@components/import/deposit-data/deposit-data-import.component';
import { ImportDialogModule } from '@components/import/import-dialog.module';
import { SettingsRoutingModule } from '@components/settings/settings-routing.module';
import { SigninOidcComponent } from '@core/auth/signin-oidc/signin-oidc.component';
import { SilentRenewRedirectComponent } from '@core/auth/silent-renew-redirect/silent-renew-redirect.component';
import { DialogModule } from '@core/dialog/dialog.module';
import { EmpyreanLoaderModule } from '@core/empyrean-loader/empyrean-loader.module';
import { ErrorPagesModule } from '@core/error-pages/error-pages.module';
import { HeaderModule } from '@core/header/header.module';
import { SharedModule } from '@core/shared.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { CanComponentDeactivateGuard } from '@guards/can-component-deactivate-guard.service';
import { NgIdleModule } from '@ng-idle/core';
import { RoutesModule } from '@routes/routes.module';
import { httpInterceptorProviders } from '@services/http-interceptors/interceptor-providers';
import { BlobModule } from 'angular-azure-blob-service';
import { ToasterModule } from 'angular2-toaster';
import 'hammerjs';
import { AppConfigProvider } from './app.config.provider';
import { NotificationComponent } from './components/notification/notification.component';
import { KendoModule } from './core/kendo/kendo.module';

registerLocaleData(localeGB, 'en');
registerLocaleData(localeGBExtra, 'en-GB');

export function appConfigProviderFactory(provider: AppConfigProvider) {
  return () => provider.load();
}

@NgModule({
  declarations: [
    //
    AppComponent,
    HomeComponent,
    SigninOidcComponent,
    SilentRenewRedirectComponent,
    // Used from the Header Component
    ExportConfigComponent,
    DepositDataImportComponent,
    ExportALMConfigComponent,
    NotificationComponent
  ],
  imports: [
    //
    BrowserAnimationsModule,
    DialogModule,
    ImportDialogModule,
    EmpyreanLoaderModule,
    ErrorPagesModule,
    FormsModule,
    HttpClientJsonpModule,
    HttpClientModule,
    KendoModule,
    MatTooltipModule,
    NgIdleModule.forRoot(),
    ReactiveFormsModule,
    RoutesModule,
    SettingsRoutingModule,
    SharedModule,
    SpreadSheetsModule,
    ToasterModule.forRoot(),
    BlobModule.forRoot(),
    HeaderModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatCardModule
  ],
  providers: [
    httpInterceptorProviders,
    AppConfigProvider,
    { provide: APP_INITIALIZER, useFactory: appConfigProviderFactory, deps: [AppConfigProvider], multi: true },
    CanComponentDeactivateGuard
  ],
  bootstrap: [AppComponent],
  entryComponents: [ExportALMConfigComponent, ExportConfigComponent],
  exports: [NotificationComponent]
})
export class AppModule {}
